import {
  Component,
  OnInit,
  Input,
  Type,
  ViewContainerRef,
  ViewChild,
  ComponentFactoryResolver,
  ComponentRef,
  Output,
  EventEmitter
} from '@angular/core';
import { DataEntity } from '../../../../models/data-entities';
import { WorkflowApplication } from '../../../../models';
import { DataEntityFactory, WorkflowContextService } from '../../../../services';
import { Activity, ActivityModel } from '../../../../models/activities';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
  selector: 'wm-data-entity-view',
  templateUrl: './data-entity-view.component.html',
  styleUrls: ['./data-entity-view.component.css'],
  standalone: false
})
export class DataEntityViewComponent implements OnInit {
  @Input() entity: DataEntity;
  @Input() application: WorkflowApplication;
  @Input() activity: Activity<ActivityModel>;
  @Input() showLabel = true;
  @Input() orientation: 'horizontal' | 'vertical' = 'vertical';
  //Added by amisha on 24/12/2025
  templateForPermitForm = false;


  @Output() calculateActivity: EventEmitter<{
    templateCode: string;
    calculateFormula?: boolean;
    visReq?: boolean;
  }> = new EventEmitter();

  @ViewChild('entityContainer', { read: ViewContainerRef, static: true })
  entityContainer: ViewContainerRef;
  componentRef: ComponentRef<DataEntityViewComponent>;

  constructor(public layoutService: LayoutService,private componentFactoryResolver: ComponentFactoryResolver, context : WorkflowContextService) {
    //Added by amisha on 24/12/2025
     layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
  }
  async persistChildComponent?() {
    return new Promise(resolve => {
      resolve(null);
    });
  }
  ngOnInit() {
    this.loadEntity();
  }

  loadEntity() {
    if (this.entity) {
      const code = this.entity.dataEntityTypeCode;
      if (!(this.entity instanceof DataEntity)) {
        this.entity = DataEntityFactory.createDataEntity(code, this.entity);
      }
      let compType: Type<DataEntityViewComponent>;

      if (this.entityContainer && this.entity.isVisible) {
        this.entityContainer.clear();

        compType = DataEntityFactory.createViewComponent(
          this.entity,
          this.entity
        );
        if (compType && this.entityContainer) {
          this.componentRef = this.entityContainer.createComponent(compType);
          this.componentRef.instance.entity = this.entity;
          this.componentRef.instance.activity = this.activity;
          this.componentRef.instance.application = this.application;
          this.componentRef.instance.showLabel = this.showLabel;
          this.componentRef.instance.orientation = this.orientation;
          this.componentRef.instance.calculateActivity = this.calculateActivity;
          //Added by amisha on 24/12/2025
          (this.componentRef.instance as any).templateForPermitForm =
            (this as any).templateForPermitForm ?? false;

          this.componentRef.instance.persistChildComponent = this.componentRef
            .instance.persistChildComponent
            ? this.componentRef.instance.persistChildComponent
            : async function () {
              return new Promise(resolve => {
                resolve(null);
              });
            };
        }
      }
    }
  }
}
